<template>
    <v-row dense align-content="center" justify="center">

        <v-col cols="2">
            <v-row dense>
                <v-card flat color="#D8F2F0">
                    <v-card-text>  
                        <v-avatar size="180px" item >
                            <v-img          
                                :src="this.icon" 
                            />  
                        </v-avatar>                                                
                    </v-card-text>                    
                    <v-card-actions>
                        <v-file-input  
                            :rules="rules"
                            v-model="imgStore"
                            accept="image/*"
                            label="Clique para Carregar"
                            prepend-icon=""
                            prepend-inner-icon="mdi-camera"
                            @change="onFileChange">
                        </v-file-input>
                    </v-card-actions>
                </v-card>
            </v-row>       
            <v-row>
                <v-spacer></v-spacer>                
            </v-row>
        </v-col>
        <v-col cols="10">
            <v-form ref="form">
                <v-row dense>
                    <v-col cols="3">
                        <v-text-field :rules="[rules.required]" v-model="id" label="ID" readonly></v-text-field>                    
                    </v-col>                              
                    <v-col cols="6">
                        <v-text-field :rules="[rules.required]" v-model="nome" label="Nome do Estabelecimento *" required></v-text-field>                    
                    </v-col>  
                    <v-col cols="3">
                        <v-text-field :rules="[rules.required]" v-model="documento" id="documento" label="CPF/CNPJ *" required @blur="validaDoc"></v-text-field>                    
                    </v-col>                  
                    <v-col cols="6">
                        <v-select :rules="[rules.required]" v-model="segmento" :items="segmentos" item-text="nome" label="Segmento *" required return-object></v-select>                    
                    </v-col>                 
                    <v-col cols="6">
                        <v-select :rules="[rules.required]" v-model="especialidade" :items="segmento.especialidades" label="Especialidade *" required></v-select>                    
                    </v-col>     
                    <v-col cols="2">
                        <v-text-field :rules="[rules.required]" id="cep" v-model="cep" label="CEP *" required hint="Obrigatório Formato 00000-000" v-on:keyup="buscar"></v-text-field>                                                    
                    </v-col>    
                    <v-col cols="8">
                        <v-text-field :rules="[rules.required]" v-model="endereco.logradouro" label="Endereco *" required readonly prepend-inner-icon="mdi-map-marker"></v-text-field>                                                    
                    </v-col>      
                    <v-col cols="2">
                        <v-text-field :rules="[rules.required]" id="numero" v-model="endereco.numero" label="Núm. *" required></v-text-field>                                                    
                    </v-col> 
                    <v-col cols="3">
                        <v-text-field :rules="[rules.required]" v-model="endereco.bairro" label="Bairro" required></v-text-field>                                                    
                    </v-col>                
                    <v-col cols="3">
                        <v-text-field v-model="endereco.complemento" label="Complemento" required></v-text-field>                                                    
                    </v-col>
                    <v-col cols="5">
                        <v-text-field :rules="[rules.required]" v-model="endereco.localidade" label="Cidade *" required readonly></v-text-field>                                                    
                    </v-col>  
                    <v-col cols="1">
                        <v-text-field :rules="[rules.required]" v-model="endereco.uf" label="UF *" required readonly></v-text-field>                                                    
                    </v-col>        
                    <v-col cols="6">
                    </v-col>       
                    <v-col cols="12">
                        <v-textarea v-model="info" label="Informações Adicionais" required rows="4" max="250" counter=250></v-textarea>                                                    
                    </v-col> 
                </v-row>
            </v-form>                                                                                                                                                                                                                                         
            <v-row>
                <v-spacer></v-spacer>
                <v-btn outlined class="ma-2 white--text" color="primary" @click="saveInfo">
                    <v-icon left dark>mdi-plus</v-icon>
                    Salvar Informações
                </v-btn>                  
            </v-row>
        </v-col>   
    </v-row>  
</template>
<script>
import {db, files} from '@/main'
import $ from 'jquery'
import dbFunctions from "@/dbFunctions"
import store from "@/store"
import utils from "@/utils"
    export default {
        data: () => ({
            rules: {
                required: value => !!value || 'Campo Obrigatório.',
                min: v => v.length >= 8 || 'Min 8 characters',
                minlength: len => v => (v || '').length >= len || `Número de Caractéres Inválido. Mínimo: ${len}`,
                maxlength: len => v => (v || '').length < len || `Número de Caractéres Inválido. Máximo: ${len}`,
            },  
            items:['ITEM1','ITEM2','ITEM3'],
            id: '',
            nome: '',
            segmento: '',
            especialidade: '',
            cep: '',
            endereco: '',
            info: '',
            imgStore: '',
            loading: false,
            icon: 'https://quoon-br.web.app/semfoto.gif',
            segmentos: '',
            especialidades: '',
            SegKey:0
        }),      
        created(){
            this.getDataInfo = dbFunctions.getDataInfo
            this.validaCPF = utils.validaCPF
            this.validaCNPJ = utils.validaCNPJ

            this.id = this.$store.getters.company.data.id
            this.nome = this.$store.getters.company.data.nome
            this.segmento = this.$store.getters.company.data.segmento
            this.especialidade = this.$store.getters.company.data.especialidade
            this.cep = this.$store.getters.company.data.cep
            this.endereco = this.$store.getters.company.data.endereco
            this.info = this.$store.getters.company.data.informacoes
            this.icon = this.$store.getters.company.data.logoUrl
            this.documento = this.$store.getters.company.data.documento
            this.segmento = this.$store.getters.company.data.segmento
            this.especialidade = this.$store.getters.company.data.especialidade
            this.loadSegments()
        }, 
        methods: {
            loadSegments(){
                db.collection('segmentos').orderBy('nome').get()
                .then((seg) => {                           
                    this.segmentos = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a});                    
                    this.SegKey += 1
                    console.log(this.segmentos,this.SegKey)
                }).catch(function (error) {
                    console.error("Error get users: ", error);
                });  
            },
            validaDoc(){
                if (!this.validaCPF(this.documento) && !this.validaCNPJ(this.documento)) {
                    $("#documento").focus();
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': 'Documento Inválido, favor preencher com CPF ou CNPJ'
                    }          
                    this.$emit("loadMessage",errorMessage)

                    return false
                }
            },
            saveInfo(){
                if (this.$refs.form.validate()) {

                    let companyInfo = {
                        nome: this.nome,
                        segmento: this.segmento,
                        especialidade: this.especialidade,
                        cep: this.cep,
                        endereco: this.endereco,
                        informacoes: this.info,
                        documento: this.documento,
                        ativo: true,
                    }
                
                   let ref = files.ref();

                    if (typeof this.imgStore.name != 'undefined'){ 
                        let imgName = 'logo' + this.imgStore.name.substring(this.imgStore.name.lastIndexOf("."), this.imgStore.name.length)
                        let mountainImagesRef = ref.child(this.$store.getters.company.data.id+'/images/'+imgName);
                        mountainImagesRef.put(this.imgStore).then(function() {
                            console.log('Uploaded a blob or file!');
                            companyInfo.logo = this.$store.getters.company.data.id+'/images/'+imgName
                        });                                
                    }
                    db.collection('empresas').doc(this.id).update(companyInfo).then(async() => {
                        this.loading = false
                        let success = {
                            'active':true,
                            'color':'success',
                            'message':'Informações Salvas com Sucesso'
                        }                
                        await this.reloadData(this.$store.getters.company.data.id)
                        this.$emit("loadMessage",success)
                        // this.$emit("productAdded")
                    }).catch(function (error) {
                        let errorMessage = {
                            'active':true,
                            'color':'error',
                            'message': error
                        }          
                        console.error('Error to Save Information - storePage : ' + error)
                        this.$emit("loadMessage",errorMessage)
                    }) 
                }               
            }, 
            async reloadData(companyId){
                let dataStore = await this.getDataInfo(companyId)
                store.dispatch("fetchData",dataStore)
            },      
            onFileChange() {
                console.log(this.imgStore)
            
                let name = 'logo' + this.imgStore.name.substring(this.imgStore.name.lastIndexOf("."), this.imgStore.name.length)
                console.log(name)

                const file = this.imgStore;
                this.icon = URL.createObjectURL(file);
            },                    
            buscar(){
                var self = this;
                
                self.naoLocalizado = false;
                
                if(/^[0-9]{5}-[0-9]{3}$/.test(this.cep)){
                    $.getJSON("https://viacep.com.br/ws/" + this.cep + "/json/", function(endereco){
                    if(endereco.erro){
                        self.endereco = {};
                        $("#logradouro").focus();
                        self.naoLocalizado = true;
                        return;
                    }
                    self.endereco = endereco;
                    console.log(endereco);
                    $("#numero").focus();
                    });
                }
            },         			
        }        
    }
</script>